import React, { useEffect, useState } from "react";
import { Box, TextField } from "@mui/material";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";
import { useSelector } from "react-redux";
import Select from "react-select";

const CpsBody = ({ obj }) => {
  const { cps, setCps, selectedGateway } = obj;
  const reducer: any = useSelector((state) => state);

  const [gateways, setGateways] = useState([]);
  const [gateway, setGateway] = useState<any>(null);
  const {
    AccountReducer: { constantData },
  } = reducer;

  useEffect(() => {
    setGateways(constantData?.gateways);

    const findGateway = constantData?.gateways?.find(
      (gw) => gw?.value === selectedGateway?.gateway_name
    );
    setGateway(findGateway);
  }, [constantData]);

  return (
    <>
      <Box className="mt-1">
        <label className="font-14-grey">Select Gateway</label>
        <Select
          isDisabled={false}
          value={gateways?.find((name: any) => name.value === gateway?.value)}
          options={gateways}
          getOptionLabel={(e: any) => e.name}
          getOptionValue={(e: any) => e.name}
          placeholder={"Select Gateway"}
          onChange={(e) => {
            setGateway(e.value);
          }}
          styles={commonStyles.customSelect}
          menuPortalTarget={document.body}
        />
      </Box>

      <Box className="mt-3 flex-column">
        <label className="font-14-grey">Set CPS</label>
        <TextField
          placeholder={"Increase CPS"}
          onChange={(e) => setCps(e.target.value)}
          name="cps"
          value={cps}
          sx={commonStyles.inputField}
          slotProps={{
            htmlInput: {
              maxLength: 25,
            },
          }}
        />
      </Box>
    </>
  );
};

export default CpsBody;
